/**
 * Shared profile mapping utilities.
 * Used by auth.service (getProfile) and profile.service (updateProfile).
 */
import type { UserProfile } from '../types/auth.types'
import type { Row } from '../types/db-rows'

/** The `profiles` row exactly as the generated schema declares it. */
export type ProfileRow = Row<'profiles'>

/** Maps snake_case DB row → camelCase application type */
export function mapProfile(row: ProfileRow): UserProfile {
  return {
    id: row.id,
    email: row.email,
    phone: row.phone,
    firstName: row.first_name,
    lastName: row.last_name,
    displayName: row.display_name,
    avatarUrl: row.avatar_url,
    avatarBlurhash: row.avatar_blurhash,
    dateOfBirth: row.date_of_birth,
    countryId: row.country_id,
    cityId: row.city_id,
    preferredLocale: row.preferred_locale,
    preferredCurrency: row.preferred_currency,
    roles: row.roles,
    isHostEnabled: row.is_host_enabled,
    isVerified: row.is_verified,
    isSuspended: row.is_suspended,
    suspendedReason: row.suspended_reason,
    suspendedUntil: row.suspended_until,
    deletedAt: row.deleted_at,
    deletionReason: row.deletion_reason,
    guestRatingAvg: row.guest_rating_avg,
    guestRatingCount: row.guest_rating_count,
    hostRatingAvg: row.host_rating_avg,
    hostRatingCount: row.host_rating_count,
    createdAt: row.created_at,
    updatedAt: row.updated_at,
    lastActiveAt: row.last_active_at,
  }
}
